import { render, staticRenderFns } from "./TradeComponent.vue?vue&type=template&id=117bc90f&scoped=true&"
import script from "./TradeComponent.vue?vue&type=script&lang=js&"
export * from "./TradeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117bc90f",
  null
  
)

export default component.exports